//
// NodeLinkDiagram.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../Region";
import "../../data/Role";
import "./ViewportOptions";

var NodeLinkDiagram = createModule("gtl::NodeLinkDiagram", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization","gtl::Region"], EventDispatcher, [
    ,
    {
        linkTip: [1],
        nodeTip: [1],
        viewportOptions: 1,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default NodeLinkDiagram;
